import React, { Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Router, Switch, Redirect } from 'react-router-dom';
import history from './history';

import Loader from 'components/Loader/Loader';

import * as LazyComponent from 'utils/lazyLoaded';
import PrivateRoute from 'utils/privateRoute';
import { supportLanguage } from 'utils/functions';
import History from 'routes/history';

import { changeLanguage } from 'actions/common/language';

const Routes = ({ language }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changeLanguage(supportLanguage(language) ? language : 'ko-kr'));

        if (History.location.pathname === '/') {
            History.push('/clientstatus');
        }
    }, []);

    return (
        <Suspense fallback={<Loader />}>
            <Router history={history}>
                <Switch>
                    <LazyComponent.SignIn path='/signin' exact />

                    <LazyComponent.Viewer path={['/viewer', '/viewer/*']} exact />

                    <PrivateRoute path='/' component={LazyComponent.Layout} />
                    <Redirect from='/' to='/clientstatus' />
                </Switch>
            </Router>
        </Suspense>
    );
};

export default Routes;
